export const ReportsRoutes = {
  app: {
    getTSToken: `/app/thoughtspot/token`,
  },
};
